/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @typedef {Object} layoutRenderOptions
 * @property {Boolean} isBackgrounRun - Indicate that the rendering is non-interactive, for example thumbnail rendering
 */

/**
 * @class LayoutAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class LayoutAPI {

		/**
		 * Return a list of of child layout APIs
		 * @function LayoutAPI#getChildrenList
		 * @return {LayoutAPI[]}
		 */
		getChildrenList() { }

		/**
		 * Get the parent layout API
		 * @function LayoutAPI#getParentLayout
		 * @return {LayoutAPI} Null is returned if this is the top level layout
		 */
		getParentLayout() { }

		/**
		 * @function LayoutAPI#getWidget
		 * Get the widget API for the widget inside this layout
		 * @return {WidgetAPI} Null is returned if the layout does not contain a widget
		 */
		getWidget() { }

		/**
		 * Shows the layout
		 * @function LayoutAPI#render
		 * @param {layoutRenderOptions} [options]
		 */
		render() { }

		/**
		 * @function LayoutAPI#getEditingActionList
		 * Get the editing actions for the widget inside this layout
		 * @return {actions[]} Array of actions for the widget inside this layout
		 */
		getEditingActionList () {}
	}

	return LayoutAPI;
});
